// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"f9f2ddc4","110":"89afd5c6","147":"c5f9c8c3","210":"7f984371","263":"b55d19d9","285":"d72979cc","453":"8ce5b620","589":"d3b94b54","631":"be04c24f","722":"889eec70","768":"332f4c97","877":"0115e3cc","882":"867a81c2"}[chunkId] + ".chunk.js";
};